import React from 'react';
import ConfirmDialog from '../../components/confirm-dialog';
import { useSnackbar } from '../../components/toast';
import { MARK_HIGH_RISK_FAILED, MARK_HIGH_RISK_SUCCESS } from '../../helpers/messages';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { IconButton } from '@mui/material';
import Utils from '../../utils';
import { CustomTooltip } from '../../consts';


const HighALertConfirmButton = ({ alertObj, onSuccess }) => {
    const [open, setOpen] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(null);
    const showSnackbar = useSnackbar();

    const handleDeleteConfirm = async () => {
        try {
            setIsLoading(true)
            const payload = {
                id: alertObj.id,
                risk: !alertObj.risk,
            };
            await Utils.genericMutation("updateAlert", payload);
            setOpen(false);
            setIsLoading(false);
            onSuccess(payload);
            showSnackbar(MARK_HIGH_RISK_SUCCESS);
        } catch (error) {
            console.log(error);
            setIsLoading(false)
            showSnackbar(MARK_HIGH_RISK_FAILED, "error");
        }
    };

    const renderConfirm = () => {
        return (<ConfirmDialog
            open={open}
            loading={isLoading}
            onClose={() => setOpen(false)}
            onConfirm={handleDeleteConfirm}
            title="Please Confirm"
            okText="Okay"
            message={`Are you sure you want to do this action?`}
        />)
    }

    const handleClick = (e) => {
        setOpen(true);
    }

    return (
        <>
            {renderConfirm()}
            <CustomTooltip title={alertObj.risk ? "High Risk" : "Set High Risk"}>
                <IconButton sx={{marginLeft: -.5}} onClick={handleClick} aria-label={alertObj.risk ? "High Risk" : "Set High Risk"}  color={alertObj.risk  ? "error" : "info"}>
                    <WarningAmberIcon />
                </IconButton>
            </CustomTooltip>
        </>
    )
}

export default HighALertConfirmButton